/**
 * Same-page anchor links (header menu, aq-hero/aq-cta buttons) should scroll to their
 * target section without touching the URL hash or browser history — a native hash
 * navigation adds a history entry per click and conflicts with cart-drawer.js's
 * popstate-based close-on-back-button behavior.
 */
document.addEventListener('click', (event) => {
  if (event.defaultPrevented) return;
  if (event.button !== 0) return;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

  const link = event.target instanceof Element ? event.target.closest('a[href*="#"]') : null;
  if (!(link instanceof HTMLAnchorElement)) return;
  if (link.target && link.target !== '_self') return;
  if (!link.hash || link.pathname !== window.location.pathname) return;

  const targetId = decodeURIComponent(link.hash.slice(1));
  const target = targetId ? document.getElementById(targetId) : null;
  if (!target) return;

  event.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
});
